import { render, staticRenderFns } from "./UserTabView.vue?vue&type=template&id=0cec4d16&"
import script from "./UserTabView.vue?vue&type=script&lang=ts&"
export * from "./UserTabView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports